<template>
  <div class="customer-container">
    <div class="welcome-section">
      <!-- 欢迎语区域 -->
      <div class="welcome-content">
        <div class="welcome-text">
          Hello! 店长，<br />
          又是元气满满的一天
        </div>
        <div class="relax-badge"></div>
      </div>
      <div class="customer-buttons">
        <!-- 查看我的客户按钮 -->
        <div class="customer-button" @click="goto(1)">
          <div class="button-content">
            <div class="button-text">查看我的客户</div>
          </div>
        </div>

        <!-- 查看门店客户按钮 -->
        <div class="store-customer-btn" @click="goto(2)">
          <div class="button-content">
            <div class="button-text">查看门店客户</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const router = useRouter();

function goto(type) {
  router.push({ path: "/customerList", query: { type } });
}
</script>

<style lang="less" scoped>
.customer-container {
  min-height: 100vh;
  padding-bottom: 70px;
}

/* 欢迎语区域 */
.welcome-section {
  padding: 28px 17px;
  position: relative;
  background-image: url("../assets/img/customer/cus-1.png");
  background-size: 100% auto;
  background-position: top;
  background-repeat: no-repeat;
  margin-bottom: 13px;
}

.welcome-content {
  .welcome-text {
    font-size: 31px;
    color: #1d2806;
    line-height: 1.4;
    font-weight: 500;
    position: relative;
    font-family: "PingFang SC-Semibold";
    z-index: 2;
  }

  .relax-badge {
    background-image: url("../assets/img/customer/cus-2.png");
    background-size: 100% auto;
    background-position: top;
    background-repeat: no-repeat;
    position: absolute;
    right: 34px;
    top: 85px;
    font-size: 14px;
    color: #1d2806;
    opacity: 0.8;
    width: 250px;
    height: 31px;
  }
}

/* 客户按钮区域 */
.customer-buttons {
  padding: 0 17px;
  margin-top: 44px;

  .customer-button {
    height: 140px;
    border-radius: 11px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    background-image: url("../assets/img/customer/cus-3.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    margin-bottom: 13px;

    .button-content {
      line-height: 140px;
      padding-left: 32px;
      .button-text {
        font-size: 23px;
        color: #654317;
        font-weight: 500;
      }
    }
  }

  .store-customer-btn {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    background-image: url("../assets/img/customer/cus-4.png");
    background-size: 100% auto;
    background-repeat: no-repeat;

    .button-content {
      line-height: 140px;
      padding-left: 19px;

      .button-text {
        font-size: 23px;
        color: #255959;
        font-weight: 500;
      }
    }
  }
}
</style>
